import { Component, OnInit, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { InputComponent } from '../input/input.component';
import { FiltreService } from '../../filtre.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { formatNumber } from '@angular/common';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-float-input',
  templateUrl: './float-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class FloatInputComponent extends InputComponent implements OnInit {
  @Input()
  max: number = 100000000;
  @Input()
  min: number = 0;
  @Input()
  classeSupplInput: string = '';
  @Input()
  nbDecimale = 2;
  @Input()
  denominateurMax: number = 5;

  valeurInvalide = false;

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
  ngOnInit() {
    super.ngOnInit();
    // Ajout de FormControl servant à l’affichage de la valeur
    if (! this.formAffichage) {
      (this.currentControl.parent as UntypedFormGroup).setControl(this.labelAffichage, new UntypedFormControl(this.currentControl.value));
    }
    // Mise en place de la cohérence entre nos deux formControls
    // Comme toujours avec les subscriptions, ne pas oublier de fermer les ressources
    // Cela est fait automatiquement par la classe mère via subTab
    this.subTab.push(
      // DebounceTime le temps de mettre un chiffre après la virgule
      this.formAffichage.valueChanges.subscribe((value: string) => {
        // Si un point ou une virgule est saisi, on attend d’avoir un caractère après. Pareil avec les zéros …
        const verifVirgule: RegExp = new RegExp('^.*[,.]0{0,' + (this.nbDecimale - 1) + '}$');

        if (!verifVirgule.test(value)) {
          const nouveauNombre = this.applicationBornes(this.texteVersNombre(value));

          this.valeurInvalide = false;
          // Pour éviter des boucles infinies, vérification que la case a vraiment été changée
          if (true || nouveauNombre !== this.currentControl.value) {
            // Dans ce cas spécifique on veut que le valueChanges s'applique pour ce control.
            // => Pas emitEvent: false
            this.currentControl.patchValue(nouveauNombre);
            this.formAffichage.patchValue(this.nombreVersTexte(nouveauNombre), {emitEvent: false});
          }
        } else {
          this.valeurInvalide = true;
        }
      })
    );
    this.subTab.push(
      this.currentControl.valueChanges.subscribe((value) => {
        this.currentControl.patchValue(this.applicationBornes(value), {emitEvent: false});
        this.formAffichage.patchValue(this.nombreVersTexte(this.applicationBornes(value)), {emitEvent: false});
      })
    );
    // On force la mise à jour des valeurs
    this.currentControl.updateValueAndValidity();
  }

  /**
   * limite les nombres possibles pour respecter les bornes définies
   * @returns nombre respectant les bornes
   */
  protected applicationBornes(valeur: number): number {
    const valeurString = valeur + '';
    // Troncature en ne gardant que deux décimales et n chiffres avant la decimale -> denominateurMax!
    const tronc = parseFloat(valeurString.substring(0, valeurString.indexOf('.') + this.denominateurMax + this.nbDecimale));

     if (valeur > this.max || valeur < this.min ||
      // On n’autorise que x chiffres après la virgule
      (! isNaN(tronc) && tronc !== valeur)) {
      // Vérification que la valeur en cours n’est pas abérente, sinon on réinitialise
      if (this.currentControl.value > this.max || this.currentControl.value < this.min) {
        return null;
      }
      // Pour l’utilisateur qui peut s’étonner de taper 153 et voir s’afficher 100
      // on laisse juste 15 (valeur du currentControl)
      return this.currentControl.value;
    } else {
      return  valeur;
    }
  }
  /** Formate un nombre pour l’affichage à la française */
  protected nombreVersTexte (valeur: number): string {
    // Attention, formatNumber arrondit en formattant (avec nbDecimale=2,
    // 1999.999 est arrondi à 2000 par exemple)
      return valeur !== null ? formatNumber(valeur, 'fr', '1.0-' + this.nbDecimale) : '';

  }
  /** Transforme l’affichage du nombre de type string en type number */
  protected texteVersNombre (valeur: string): number {
    if (valeur) {
      // Le pattern /\s/g supprime globalement tous les types de caractères
      // d'espacement de la chaîne de caractères (et donc l'espace séparant les
      // milliers des centaines ajouté par formatNumber')
      const nombre: any = parseFloat(valeur.replace(/\s/g, '').replace(new RegExp(',', 'g'), '.'));

      return isNaN(nombre) ? null : nombre;
    } else {
      return null;
    }
  }
  /** Besoin de réécrire cette fonction pour travailler sur le champ visible à l’écran */
  champTouche() {
    return this.formAffichage.touched;
  }
  /** Retourne le FormControl servant à l’affichage qui n’est plus le même que le FormControl d’origine */
  get formAffichage (): UntypedFormControl {
    return this.currentControl.parent.get(this.labelAffichage) as UntypedFormControl;
  }
  /** Label à affecter au FormControl servant à l’affichage */
  get labelAffichage (): string {
    return this.label + '_affichage';
  }

  champInvalide() {
    return this.currentControl.invalid || this.valeurInvalide;
  }

}
